import O1HD from "../../../../engines/gameEngine";
import NormalGameManager from "../../manager/NormalGameManager";
import ChickenPrefab from "./ChickenPrefab";
import {ChickEntity} from "./config/ChickConfig";
import {ChickenCacheEntity} from "../../manager/DefineInterface";

const {ccclass, property} = cc._decorator;
/**
 * 购买item
 */
@ccclass
export default class PurchaseItemPrefab extends cc.Component {

    @property(sp.Skeleton)
    youngChickenSp : sp.Skeleton = null;
    @property(cc.Label)
    lbTitle : cc.Label = null;
    @property(cc.Label)
    lbDesc : cc.Label = null;
    @property(cc.Label)
    lbPrice : cc.Label = null;
    @property(cc.Node)
    eggNodeArray : cc.Node[] = [];

    private mGameLayer : NormalGameManager;
    private mParentScript : ChickenPrefab;
    private mChickEntity : ChickEntity;

    onLoad () {}

    start () {
        this.mGameLayer = NormalGameManager._instance;
    }

    /**
     * 绑定数据
     * @param chickEntity
     */
    bindData( chickEntity : ChickEntity , parentScript : ChickenPrefab ){
        this.mChickEntity = chickEntity;
        this.mParentScript = parentScript;
        //设置样子
        this.scheduleOnce(()=>{
            this.youngChickenSp.setSkin( this.mChickEntity.imgPath );
            this.youngChickenSp.setToSetupPose();
        });
        this.lbTitle.string = `${this.mChickEntity.name}鸡苗`;
        this.lbDesc.string = `简介:${this.mChickEntity.desc}`;
        this.lbPrice.string = `${this.mChickEntity.purchasePrice}元/只`;
        if ( this.mChickEntity.eggWeightArray ) {
            for ( let item of this.mChickEntity.eggWeightArray ) {
                switch ( item.goodsId ) {
                    case 21001:this.eggNodeArray[0].active = true;break;
                    case 21002:this.eggNodeArray[1].active = true;break;
                    case 21003:this.eggNodeArray[2].active = true;break;
                    case 21004:this.eggNodeArray[3].active = true;break;
                    case 21005:this.eggNodeArray[4].active = true;break;
                    case 21006:break;
                    case 21007:this.eggNodeArray[5].active = true;break;
                }
            }
        }
    }

    /**
     * 购买
     */
    onBtnPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( ( this.mGameLayer.getGameData().batchingBinData.length + this.mGameLayer.getGameData().chickenData.length )
            >= this.mGameLayer.getGameData().chickenCoop.capacity ) {
            O1HD.getModules().uiControlModule.showMessageBox("孵化加鸡数量已达到鸡仓上限" );
            this.mParentScript.openEnlargeCapacity();
            return;
        }
        // 添加数据 增加渲染
        if ( O1HD.getServices().userSrv.getCoins() < this.mChickEntity.purchasePrice ) {
            O1HD.getModules().uiControlModule.showMessageBox("金钱不足");
            
            NormalGameManager._instance.openBankPage();
            return;
        }

        O1HD.getServices().userSrv.setCoins( -this.mChickEntity.purchasePrice , true );
        let currMill = new Date().getTime();
        let chickenCacheEntity : ChickenCacheEntity = {
            bornGameHour: this.mGameLayer.mGameHours,
            bornGameMinute: this.mGameLayer.mMinute,
            chickenId: this.mChickEntity.id,
            lastLayHour: this.mGameLayer.mGameHours,
            lastLayMinute: this.mGameLayer.mMinute,
            uniqueId: currMill,
        }
        this.mGameLayer.getGameData().chickenData.push( chickenCacheEntity );
        this.mGameLayer.writeGameData();
        O1HD.getModules().uiControlModule.showMessageBox("购买成功");
        this.mParentScript.addChickItemNode( chickenCacheEntity );
    }



}
